export const ProfileImportNetworkListTab = {
  Merge: 'merge',
  Import: 'import',
};
